/* eslint-disable react/display-name */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Spinner from 'components/loaders/Spinner/Spinner';
import styles from './style.cssmodule.css';

const Button2 = forwardRef(({
  type,
  htmlType,
  size,
  className,
  iconOnly,
  style,
  children,
  loading,
  disabled,
  onClick,
  ...otherProps // For others props like aria-label
}, ref) => (
  <button
    ref={ref}
    type={htmlType}
    style={style}
    className={`${styles.button} ${type ? styles[type] : null} ${iconOnly ? styles.iconOnly : null} ${styles[size]} ${className}`}
    disabled={disabled}
    onClick={onClick}
    {...otherProps}
  >
    {loading
    && (
    <div className={styles.spinnerContainer}>
      <Spinner />
    </div>
    )}
    <div className={styles.content} style={{ visibility: loading ? 'hidden' : 'visible' }}>
      {children}
    </div>
  </button>
));

Button2.propTypes = {
  type: PropTypes.oneOf(['primary', 'primaryOutline', 'secondaryOutline', 'info', 'success', 'warning', 'alert']),
  htmlType: PropTypes.oneOf(['button', 'submit', 'reset']),
  size: PropTypes.oneOf(['small', 'medium']),
  className: PropTypes.string,
  iconOnly: PropTypes.bool,
  style: PropTypes.object,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
};

Button2.defaultProps = {
  type: 'primary',
  htmlType: 'button',
  size: 'medium',
  className: '',
  style: null,
  iconOnly: false,
  loading: false,
  disabled: false,
  onClick: () => {},
};

export default Button2;



// WEBPACK FOOTER //
// ./components/buttons/Button2/Button2.jsx